import { useFragment } from '@provision/graphql-client';
import { MESSAGE_REPLY_FIELDS } from 'src/graphql/entities/conversation-message-reply/conversation-message-reply.operations';
import { MessageReply } from 'src/graphql/entities/conversation-message-reply/conversation-message-reply.types';

/** A cached reply, or undefined while it isn't fully cached. */
export function useMessageReply(replyId: string): MessageReply | undefined {
  const fragment = useFragment<MessageReply>({
    fragment: MESSAGE_REPLY_FIELDS,
    fragmentName: 'MessageReplyFields',
    from: { __typename: 'ConversationMessage', id: replyId },
  });
  return fragment.complete ? fragment.data : undefined;
}
